import * as React from 'react';

export const ClearIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Trailing">
      <path
        id="times-circle"
        d="M9.99996 1.66895C5.39996 1.66895 1.66663 5.40228 1.66663 10.0023C1.66663 14.6023 5.39996 18.3356 9.99996 18.3356C14.6 18.3356 18.3333 14.6023 18.3333 10.0023C18.3333 5.40228 14.6 1.66895 9.99996 1.66895ZM12.9416 12.0606C13.1833 12.3023 13.1833 12.7023 12.9416 12.944C12.8166 13.069 12.6583 13.1273 12.5 13.1273C12.3416 13.1273 12.1833 13.069 12.0583 12.944L9.99996 10.8856L7.94163 12.944C7.81663 13.069 7.65829 13.1273 7.49996 13.1273C7.34163 13.1273 7.18329 13.069 7.05829 12.944C6.81663 12.7023 6.81663 12.3023 7.05829 12.0606L9.11663 10.0023L7.05829 7.94397C6.81663 7.7023 6.81663 7.30225 7.05829 7.06059C7.29996 6.81892 7.69996 6.81892 7.94163 7.06059L9.99996 9.11895L12.0583 7.06059C12.3 6.81892 12.7 6.81892 12.9416 7.06059C13.1833 7.30225 13.1833 7.7023 12.9416 7.94397L10.8833 10.0023L12.9416 12.0606Z"
        fill="black"
      />
    </g>
  </svg>
);
